<template>
  <div>
    <div class="x-editor">
      <div v-if="$store.state.editor">
        <edit-button v-on:click="toggleEditor" />
        <div class="editor-holder" v-if="showEditor" :class="{floating: floating}">
          <vue-editor v-model="text" :saveComplete="saved" v-on:save="handleSave" v-on:close="handleClose" />
        </div>
      </div>
      <div v-html="text" class="x-quill-ps" ref="tfield"></div>
    </div>
  </div>
</template>

<script>
import EditButton from '@/components/buttons/EditButton.vue'

export default {
  components: {
    'vue-editor': () => import(/* webpackChunkName: "editor" */ '@/components/editors/QuillEditor.vue'),
    'edit-button': EditButton
  },
  props: {
    loaded: Boolean,
    page: String,
    item: String,
    floating: Boolean
  },
  data () {
    return {
      text: '',
      loading: false,
      showEditor: false,
      saved: true
    }
    
  },
  created () {
    this.init()
  },
  mounted () {
    this.$k.linkifyText(this.$refs.tfield)
  },
  methods: {
    init: async function () {
      if(this.loaded) {
        this.text = this.$k.getStoryLocal(this.page, this.item)
        if(this.$refs.tfield) {
          this.$k.linkifyText(this.$refs.tfield)
        }
      }
    },
    toggleEditor: function () {
      this.showEditor = !this.showEditor
    },
    handleSave: async function () {
      let t = this.text
      this.saved = false
      await this.$k.saveStory(this.page, this.item, t)
      await this.$k.waitfor(400)
      this.saved = true
      this.showEditor = false
      this.$emit('save', t)
    },
    handleClose: function () {
      this.showEditor = false
    }
  },
  watch: {
    page: function () {
      this.init()
    },
    item: function () {
      this.init()
    },
    loaded: function () {
      this.init()
    }
  }

}
</script>
<style>
.x-quill-ps p {
  margin:0;
  padding:0;
  line-height:1.4em;
}

.x-quill-ps ul{
  margin:0;
  line-height:1.4em;
}

.x-quill-ps .ql-indent-1{
  margin-left:10px;
}

.x-quill-ps li{
  margin-bottom:5px;
}

.ql-editor{
  max-height:calc(65vh - 100px);
  overflow-y:scroll;
}

</style>
<style scoped>
.x-editor{
  position: relative;
  min-width:100px;
}

.button-panel{
  padding:8px;
}

.editor-holder{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  z-index:10;
  background-color:#fff;

}

.editor-holder.floating{
  position:fixed;
  top:20px;
  right:20px;
  width:50vw;
  z-index:1000;
  max-height:50vh;
  overflow-y:auto;
}


</style>
